var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "information-text-block d-flex flex-column ga-3",
      attrs: { "data-qa": "lpu_information_text_block" },
    },
    [
      _c("h3", { staticClass: "text-subtitle-1 text--text" }, [
        _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "information-text-block__html text-body-2 text--text text-break",
        domProps: {
          innerHTML: _vm._s(_vm.html /* eslint-disable-line vue/no-v-html */),
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }